import { GymReportKind } from "@complete-athlete/enums";

/**
 * What an athlete can report about a listed gym (a missing gym is reported elsewhere). A route's
 * address is checked in the part of it that loads with every page, so this stays away from the
 * page's own code.
 */
export const PLACE_REPORT_KINDS = [
  GymReportKind.CLOSED,
  GymReportKind.NOT_EXISTS,
  GymReportKind.OPENING_HOURS,
  GymReportKind.EQUIPMENT,
  GymReportKind.DETAILS,
] as const;
export type PlaceReportKind = (typeof PLACE_REPORT_KINDS)[number];
